// Industries, clients and company milestones for HIG Automation.
// Edit this file to update industry sectors, client names and growth milestones.

export const industries = [
  {
    name: "Automotive",
    image:
      "https://images.unsplash.com/photo-1581091212991-8891c7d4bd9b?crop=entropy&cs=srgb&fm=jpg&q=85",
    clients: "Honda · Jindal Aluminium",
    services: [
      "Pneumatic clamping & testing stations",
      "Assembly fixtures and jigs",
      "Leak testing machines",
      "Calibration of control systems",
    ],
  },
  {
    name: "Electronics & EMS",
    image:
      "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&q=85",
    clients: "JBM Group · Siemens",
    services: [
      "Robotic pick-and-place systems",
      "Cleanroom-compatible fabrication",
      "SPMs for soldering, testing & component handling",
      "Precision panels & enclosures",
    ],
  },
  {
    name: "Pharma & Medical Devices",
    image:
      "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&q=85",
    clients: "Polymed · Craftsman Automation",
    services: [
      "AHU systems for cleanroom environments",
      "Utility line installations",
      "Compressed air quality systems",
      "Preventive maintenance contracts",
    ],
  },
  {
    name: "Machine Tools & MFG",
    image:
      "https://images.unsplash.com/photo-1455165814004-1126a7199f9b?crop=entropy&cs=srgb&fm=jpg&q=85",
    clients: "Craftsman Automation · Sunbeam",
    services: [
      "Control panel design & build",
      "Tooling stands & material handling carts",
      "Pneumatic jigs & fixtures",
      "Job-work fabrication",
    ],
  },
];

export const clients = [
  "Honda",
  "Siemens",
  "JBM Group",
  "Craftsman Automation",
  "Jindal Aluminium",
  "Polymed",
  "Sunbeam",
];

export const milestones = [
  {
    date: "June 2025",
    title: "Company Incorporated",
    desc: "HIG Automation India Pvt. Ltd. officially registered. Core team assembled with a shared vision.",
  },
  {
    date: "July 2025",
    title: "Production Commenced",
    desc: "Started operations at rented facility in Bawal.",
  },
  {
    date: "FY 2025–26",
    title: "SPM Started",
    desc: "Expanded engineering capability while serving industry-leading clients.",
  },
  {
    date: "April 2026",
    title: "New Factory",
    desc: "800 sqm purpose-built facility in Rewari opens, enabling larger-scale projects.",
  },
  {
    date: "2027–28",
    title: "Expansion",
    desc: "Planned expansion in certifications, capability and team size.",
  },
];
